import React from 'react';
import { PrismicAccountBusinessProfile } from '../../types/prismic';
import { BusinessStatus } from './Account';
import Box, { Header, IconBox } from './Box';

type Props = {
  handleBusinessClick: (e: React.MouseEvent) => void;
  businessProfileStatus: BusinessStatus;
  content: PrismicAccountBusinessProfile;
};

const BusinessProfile = ({
  businessProfileStatus,
  handleBusinessClick,
  content,
}: Props) => {
  return (
    <Box onClick={handleBusinessClick}>
      <IconBox>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38.147"
          height="38.147"
          viewBox="0 0 38.147 38.147"
        >
          <g id="np_store_1827481_000000" transform="translate(-9.996 -10.059)">
            <path
              id="Path_543"
              data-name="Path 543"
              d="M10.473,14.68h.678V47.729a.477.477,0,0,0,.477.477H46.509a.477.477,0,0,0,.477-.477l0-33.049h.678a.477.477,0,0,0,.477-.477V10.535a.477.477,0,0,0-.477-.477H10.473a.477.477,0,0,0-.477.477V14.2a.478.478,0,0,0,.477.477ZM46.035,44.293H36.872v-21.7h9.162Zm-27.815-4.5v7.456H15.64V39.794Zm.954,0h2.58v7.456h-2.58Zm3.533,0h2.58v7.456h-2.58Zm3.535,0h2.58v7.456h-2.58Zm3.533,0h2.58v7.456h-2.58Zm3.533,0h2.608v7.456H33.309Zm2.61-.954H12.106V22.591H35.919Zm-23.812.954h2.58v7.456h-2.58Zm24.766,7.456V45.245h9.162v2.006Zm9.162-25.614H12.107V14.68H46.035ZM10.95,11.011H47.19v2.714H10.95Z"
              transform="translate(0 0)"
              fill="#ab5742"
            />
            <path
              id="Path_544"
              data-name="Path 544"
              d="M18.308,61.193l1.868,1.868a.477.477,0,0,0,.674-.674l-1.868-1.868a.477.477,0,1,0-.674.674Z"
              transform="translate(-4.275 -26.326)"
              fill="#ab5742"
            />
            <path
              id="Path_545"
              data-name="Path 545"
              d="M22.971,60.262a.477.477,0,1,0,.674-.674l-3.757-3.757a.477.477,0,0,0-.674.674Z"
              transform="translate(-4.749 -23.873)"
              fill="#ab5742"
            />
          </g>
        </svg>
      </IconBox>
      {businessProfileStatus === BusinessStatus.NOT_CREATED && (
        <>
          <Header>{content.data.account_brand_create_header}</Header>
          <p>{content.data.account_brand_create_description}</p>
        </>
      )}
      {businessProfileStatus === BusinessStatus.CREATED && (
        <>
          <Header>{content.data.account_brand_update_header}</Header>
          <p>{content.data.account_brand_update_description}</p>
        </>
      )}
      {businessProfileStatus === BusinessStatus.UPDATED && (
        <>
          <Header>{content.data.account_brand_header}</Header>
          <p>{content.data.account_brand_description}</p>
        </>
      )}
      {businessProfileStatus === BusinessStatus.NEEDS_UPDATE && (
        <>
          <Header>{content.data.account_brand_needs_update_header}</Header>
          <p>{content.data.account_brand_needs_update_description}</p>
        </>
      )}
    </Box>
  );
};

export default BusinessProfile;
